import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { JobsiteChecksSettingsDto } from '../../../../shared/remote-services/dtos/jobsite-checks.model'
import { WarningChecksSettingsDialogResult } from '../../models/warning-checks-settings.model'

@Component({
  selector: 'warning-checks-settings-dialog',
  template: `
    <warning-checks-settings
      [data]="data"
      (saveEvent)="closeDialog($event)"
      (closeEvent)="closeDialog(null)"
      (resetEvent)="closeDialog($event, true)"
    ></warning-checks-settings>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WarningChecksSettingsDialogComponent {
  private dialogRef =
    inject<
      MatDialogRef<JobsiteChecksSettingsDto, WarningChecksSettingsDialogResult>
    >(MatDialogRef)
  data = inject<Readonly<JobsiteChecksSettingsDto>>(MAT_DIALOG_DATA)

  closeDialog(result: JobsiteChecksSettingsDto | null, isReset = false): void {
    this.dialogRef.close({
      isReset,
      result: result,
    })
  }
}
